import { Fields } from '@measured/puck';
import { GapOptions } from '../../utils/constants';

export type GapProps = {
  gap: string;
};

export const gapField: Fields<GapProps> = {
  gap: {
    type: 'select',
    label: 'Gap',
    options: GapOptions,
  },
};
